<form class="container-fluid border" [formGroup]="callCenterReservationForm" *ngIf="componentType==3">
    <div class="py-3" [hidden]="componentType==3">
        <div class="container-fluid">
            <div class="form-group d-flex">
                <label for="birthPlace">{{'REGISTERED' | translate}}</label>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" #existedCheckBox1 class="custom-control-input" [(ngModel)]="existedPatient"
                        [ngModelOptions]="{standalone: true}" name="existedPatCheck"
                        (change)="existedPatientFun(existedCheckBox1.checked)">
                    <span class="custom-control-indicator"></span>
                </label>
            </div>
        </div>

        <div class="col-sm-6" [hidden]="existedPatient == false">
            <div class="form-group">
                <sanabel-selectize appcode="1023" #patientSelectize formControlName="patCode"></sanabel-selectize>
            </div>
        </div>
       
        <!---------------------*ngIf="componentType ==2"--------------------------->
        <div class="row col-sm-12" *ngIf="componentType ==2">
            <div class="row">
                <label class="col-sm-5">{{'PATNUM' | translate}}</label>
                <input type="text" class="form-control form-control-sm col-sm-2" [(ngModel)]="patnum"
                    [ngModelOptions]="{standalone: true}" name="patnum" autofocus>
            </div>
            <div class="row">
                <label for="birthPlace">{{'UNKNOWNPAT' | translate}}</label>
                <label class="custom-control custom-checkbox">
                    <input type="checkbox" #knownCheckBox class="custom-control-input" [(ngModel)]="known"
                        [ngModelOptions]="{standalone: true}" name="known" (change)="knownFun(knownCheckBox.checked)">
                    <span class="custom-control-indicator"></span>
                </label>
            </div>
            <div class="row" [hidden]="known==false">
                <label class="col-sm-5">{{'APPROXAGE' | translate}}</label>
                <input type="text" class="form-control form-control-sm col-sm-2" formControlName="approxAge" autofocus>
            </div>
        </div>
    </div>
    <div>
        <div class="row">
            <button class="btn btn-info rounded-0 mt-2 mb-2 p-2" (click)="activeSelect = !activeSelect">
                {{ 'MODIFAYPAIENT' | translate }}
            </button>
            <div class="col-sm-3" *ngIf="activeSelect">
                <!-- <label>{{ 'EXPECTEDSERVICEPATIENT' | translate  }}</label> -->
                <sanabel-selectize appcode="1262" [simpleView]="true" formControlName="code"
                    (clicked)="addSelect($event)">
                </sanabel-selectize>
            </div>

        </div>
        <h6 class="card-header">{{'BasicData' | translate}}</h6>
        <div class="card-block">
            <name-component [namingTranslationSetting]="namingTranslationSettings" [serachAsCall]="serachAsCall" #name>
            </name-component>

        </div>

        <div [hidden]="known==true">
            <h6 class="card-header">{{'IDENTITY' | translate}}</h6>
            <div class="container-fluid py-3">
                <div>
                    <identity-component #identity (identityValueInfoEmitted)="identityValueInfoEmitted($event)">
                    </identity-component>
                </div>
                <div class="row">

                    <div class="col-sm-6 form-group">
                        <label for="birthPlace">{{'BirthPlace' | translate}}</label>
                        <input class="form-control form-control-sm" type="text" id="birthPlace"
                            formControlName="birthPlace" tabindex="12">
                    </div>

                    <div class="col-sm-6">
                        <div class="form-group">
                            <label for="birthDateNgb">{{ 'BIRTHDATE' | translate }}</label>
                            <div class="input-group input-group-sm">
                                <input class="form-control" placeholder="{{'BIRTHDATE' | translate}}"
                                    formControlName="birthDateNgb" ngbDatepicker
                                    [minDate]="{'year':1900,'month':1,'day':1}" [maxDate]="today"
                                    #birthDateNgb="ngbDatepicker">
                                <div class="input-group-addon" (click)="birthDateNgb.toggle()">
                                    <i class="fa fa-calendar"></i>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3">

                        <div class="form-group">
                            <label>{{'MOBILENUMBER' | translate}}</label>
                            <input class="form-control form-control-sm" type="text" formControlName="mobile"
                                tabindex="18" (blur)="onKeyMobile($event)" />
                        </div>

                        <div *ngIf="callCenterReservationForm.controls['mobile'].errors && (callCenterReservationForm.controls['mobile'].dirty || callCenterReservationForm.controls['mobile'].touched)"
                            class="alert alert-danger">

                            <!-- <small [hidden]="!incorrectMobile">
                                {{'INCORRECTMOBILE' | translate}}
                            </small> -->

                            <small [hidden]="!callCenterReservationForm.controls['mobile'].errors.pattern">
                                {{'INCORRECT' | translate}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3">

                        <div class="form-group">
                            <label>{{'HomePhone' | translate}}</label>
                            <input class="form-control form-control-sm" type="text" formControlName="homePhone"
                                tabindex="18" />
                        </div>

                        <div *ngIf="callCenterReservationForm.controls['homePhone'].errors && (callCenterReservationForm.controls['homePhone'].dirty || callCenterReservationForm.controls['homePhone'].touched)"
                            class="alert alert-danger">

                            <small [hidden]="!callCenterReservationForm.controls['homePhone'].errors.pattern">
                                {{'INCORRECT' | translate}}
                            </small>
                        </div>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                        <label>{{ 'GENDER' | translate }}</label>
                        <sanabel-selectize appcode="1" [simpleView]="true" formControlName="gender">
                        </sanabel-selectize>
                    </div>
                    <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                        <label class="small">{{'HOWTOREACHUS' | translate}}</label>
                        <sanabel-selectize appcode="315" [tabindex]="15" formControlName="howToReachUs"
                            [simpleView]="true">
                        </sanabel-selectize>
                    </div>

                </div>
                <div>
                    <address-component #address [tabindex]="21"></address-component>
                </div>

            </div>

        </div>
    </div>

    <!--------------------Contract ID Componnent ----------------->
    <div class="container-fluid">
        <h6 class="card-header">{{'Contract' | translate}}</h6>
        <div class="row">
            <div class="col">
                <Contract-Id #therapeuticCards (contractValueInfoEmitted)="contractValueInfoEmitted($event)">
                </Contract-Id>
            </div>
        </div>
    </div>

    <!-----------------MARK PAT EXPECTED SERVICE------------------>
    <div *ngIf="showExpectedServices && !activeSelect">
        <h6 class="card-header">{{'MARKPATEXPECTEDSERVICE' | translate}}</h6>
        <div class="row" style="margin-top: 25px;">
            <div class="col-sm-3" style="margin-top: 28px;">
                <div class="form-group">
                    <sanabel-selectize appcode="1015" formControlName="patientServiceLevelOne" #parentServiceSelectize
                        [rows]="1000" [simpleView]="true" (clicked)="onParentServiceClicked($event)">
                    </sanabel-selectize>
                </div>
            </div>

            <div class="col-sm-3" style="margin-top: 28px;">
                <div class="form-group">
                    <!-- [SearchKeys]="{Level:searchLevelTwo}" -->
                    <sanabel-selectize appcode="1038" formControlName="patientServiceLevelTwo" #childServiceSelectize
                        (clicked)="onChildServiceClicked($event)" [rows]="1000" [simpleView]="true">
                    </sanabel-selectize>
                </div>
            </div>

            <div class="col-sm-3" style="margin-top: 28px;">
                <div class="form-group">
                    <sanabel-selectize appcode="1054" [selectizeData]="true" formControlName="patientServiceLevelThree"
                        #thirdChildServiceSelectize [simpleView]="true" (clicked)="onThirdChildServiceClicked($event)"
                        [rows]="1000">
                    </sanabel-selectize>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="form-group">
                    <label for="expectedDate">{{ 'EXPECTEDDATE' | translate }}</label>
                    <div class="input-group input-group-sm">
                        <input class="form-control" placeholder="{{'EXPECTEDDATE' | translate}}"
                            formControlName="expectedDate" ngbDatepicker #expectedDate="ngbDatepicker">
                        <div class="input-group-addon" (click)="expectedDate.toggle()">
                            <i class="fa fa-calendar"></i>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="row">
            <!-- <div class="col-sm-3">
                <div class="form-group">
                    <sanabel-selectize appcode="313" formControlName="leadType">
                    </sanabel-selectize>
                </div>
            </div> -->
            <div class="col-sm-3">
                <div class="form-group">
                    <sanabel-selectize appcode="1446" formControlName="leadType">
                    </sanabel-selectize>
                </div>
            </div>

            <div class="col-sm-3">
                <div class="form-group">
                    <sanabel-selectize appcode="1014" formControlName="doctorID">
                    </sanabel-selectize>
                </div>
            </div>

            <div class="col-sm-3">
                <label for="cost">{{ 'COST' | translate }}</label>
                <input type="number" id="cost" class="form-control" formControlName="cost" />
            </div>
            <!-- مش هيبص علي خطوات ولا جدولة الخدمة  -->
            <div class="col-sm-3">
                <label for="cost">{{ 'ترتيب اتصال بعد عدة ايام' | translate }}</label>
                <input type="number" id="futureCallExpectedAfterDays" class="form-control"
                    formControlName="futureCallExpectedAfterDays" />
            </div>

        </div>
    </div>
    <div class="row" *ngIf="showExpectedServices && activeSelect">
        <div class="col-sm-3">
            <div class="form-group">
                <sanabel-selectize appcode="1014" formControlName="doctorID">
                </sanabel-selectize>
            </div>
        </div>
        <!-- <div class="col-sm-3">
                <div class="form-group">
                    <sanabel-selectize appcode="313" formControlName="leadType">
                    </sanabel-selectize>
                </div>
            </div> -->
        <div class="col-sm-3">
            <div class="form-group">
                <sanabel-selectize appcode="1446" formControlName="leadType">
                </sanabel-selectize>
            </div>
        </div>
    </div>
    <!-----------------MARK PAT EXPECTED SERVICE------------------>

</form>


<form [formGroup]="callCenterReservationForm" *ngIf="componentType !=3">
    <!-------------------CALLER DATA INFO PANNER------------------>
    <div class="callInfo container-fluid" *ngIf="showClientCallData">
        <div class="row">
            <div class="col-10">
                <div class="row">
                    <div class="col-4  align-items-center mt-2">
                        <span *ngIf="!existedPatient">{{'CALLERNAME' | translate}}: </span>
                        <span *ngIf="existedPatient">{{'CHECKEDINPAT' | translate}}: </span>
                        <small class="font-weight-bold">
                            {{translate.currentLang == 'ar' ? callerData?.fullnameAr : callerData?.fullnameEn}}
                        </small>
                    </div>
                    <div class="col-2  align-items-center mt-2" *ngIf="existedPatient">
                        <span>{{'visitNum' | translate}}: </span>
                        <small class="font-weight-bold">
                            {{callerData?.visitSerial}}
                        </small>
                    </div>

                    <div class="col-3  align-items-center mt-2">
                        <span>{{'LASTCALLDATE' | translate}}: </span>
                        <small class="font-weight-bold">
                            {{callerData?.regDate | date :'short'}}
                        </small>
                    </div>

                    <div class="col-3  align-items-center mt-2" *ngIf="showLeads" (click)="showAll(6689)"
                        style="cursor: pointer;color: #4f9be6; font-weight: bold;">
                        <span>{{'HASLEADS' | translate}} </span>
                    </div>
                </div>
                <div class="row">

                    <div class="col-2  align-items-center mt-2">
                        <span>{{'CALLREASON' | translate}}: </span>
                        <small class="font-weight-bold">
                            {{translate.currentLang == 'ar' ? callerData?.callReasonNameAr :
                            callerData?.callReasonNameEn}}
                        </small>
                    </div>
                    <div class="col-2  d-flex align-items-center mt-2">
                        <span class="text-primary mx-2">
                        </span>
                        <div style="color: red;" class="" title="{{callerData?.chronicToolTip}}">
                            <small *ngIf="callerData?.chronic==1" class="font-weight-bold">

                                {{ 'CHRONIC' | translate }}
                            </small>
                        </div>

                    </div>
                    <div class="col-2  align-items-center mt-2">
                        <span>{{'CALLERSTATUS' | translate}}: </span>
                        <small class="font-weight-bold">
                            {{translate.currentLang == 'ar' ? callerData?.callerStatusAr : callerData?.callerStatusEn}}
                        </small>
                    </div>
                    <div class="col-3  align-items-center mt-2">
                        <span *ngIf="callerData?.stopflag!=1">{{'NOTES' | translate}}: </span>
                        <small *ngIf="callerData?.stopflag!=1" class="font-weight-bold">
                            {{callerData?.notes}}
                        </small>
                        <h5 style="color:red" *ngIf="callerData?.stopflag==1">
                            <small class="font-weight-bold">
                                <!-- تم وقف التعامل مع المريض -->
                                {{'UI47' | translate}}:
                            </small>
                            <small class="font-weight-bold">
                                ({{translate.currentLang == 'ar' ? callerData?.stopFlagDescAr :
                                callerData?.stopFlagDescEn}})
                            </small>
                        </h5>

                    </div>
                    <div class="col-3 align-items-center mt-2">
                        <small class="font-weight-bold" style="color: blue;">
                            ({{translate.currentLang == 'ar' ? callerData?.drGeneralNotes :
                            callerData?.drGeneralNotes}})
                        </small>

                    </div>


                </div>
            </div>
            <div class="col-2">
                <div class="row">
                    <div class="col form-group align-items-center">
                        <div class="row align-items-center">
                            <div class="col-2 customFlag">
                                <icon-action (clicked)="showAll($event)"
                                    [appCodes]="[6687,6688,6689,6969,7004,2132,7350]">
                                </icon-action>
                            </div>
                            <div class="col-8">
                                <label> <span class="custom-control-description">{{ 'DISPLAYALL' | translate
                                        }}</span></label>
                            </div>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>

    <div class="savedCallInfo container-fluid" *ngIf="showSavedCallerData">
        <div class="row">
            <div class="col-2 align-items-center mt-2">
                <span class="font-weight-bold">{{'CALLERCODE' | translate}}: </span>
                <small>
                    {{ savedPatientData?.callerCode }}
                </small>
            </div>
            <div class="col-2 align-items-center mt-2">
                <span class="font-weight-bold">{{'CALLERNAME' | translate}}: </span>
                <small>
                    {{translate.currentLang == 'ar' ? savedPatientData?.fullnameAr : savedPatientData?.fullnameEn}}
                </small>
            </div>
            <div class="col-2 align-items-center mt-2">
                <span class="font-weight-bold">{{'MOBILE' | translate}}: </span>
                <small>
                    {{savedPatientData?.phoneNumber}}
                </small>
            </div>
            <div class="col-2 align-items-center mt-2">
                <span class="font-weight-bold">{{'CALLREASON' | translate}}: </span>
                <small>
                    {{translate.currentLang == 'ar' ? savedPatientData?.callReasonNameAr :
                    savedPatientData?.callReasonNameEn}}
                </small>
            </div>
            <div class="col-2 align-items-center mt-2">
                <span class="font-weight-bold">{{'doctorName' | translate}}: </span>
                <small>
                    {{translate.currentLang == 'ar' ? savedPatientData?.docNameAr :
                    savedPatientData?.docNameEn}}
                </small>
            </div>
        </div>

        <div class="row">
            <div class="col-2 align-items-center mt-2">
                <span class="font-weight-bold">{{'CALLERRESULT' | translate}}: </span>
                <small>
                    {{translate.currentLang == 'ar' ? savedPatientData?.callResultNameAr :
                    savedPatientData?.callResultNameEn}}
                </small>
            </div>

            <div class="col-2 align-items-center mt-2">
                <span class="font-weight-bold">{{'CALLERSTATUS' | translate}}: </span>
                <small>
                    {{translate.currentLang == 'ar' ? savedPatientData?.callerStatusAr :
                    savedPatientData?.callerStatusEn}}
                </small>
            </div>

            <div class="col-2 align-items-center mt-2">
                <span class="font-weight-bold">{{'RESERVATIONDATE' | translate}}: </span>
                <small>
                    {{savedPatientData?.regDate | date:'dd/MM/yyyy'}}
                </small>
            </div>

            <div class="col-2 align-items-center mt-2">
                <span class="font-weight-bold">{{'VisitDate' | translate}}: </span>
                <small>
                    {{savedPatientData?.reservationDate | date:'dd/MM/yyyy'}}
                </small>
            </div>

            <div class="col-2 align-items-center mt-2">
                <span class="font-weight-bold">{{'USERNAME' | translate}}: </span>
                <small>
                    {{translate.currentLang == 'ar' ? savedPatientData?.userNameAr : savedPatientData?.userNameEn}}
                </small>
            </div>
            <div class="col-2 align-items-center">
                <button type="button" class="btn btn-success" (click)="onReservationAgainClick()"> {{translate.currentLang == 'ar' ? 'حجز مرة أخرى' : 'New Reservation Again'}}</button>
            </div>
        </div>
    </div>

    <div class="container-fluid">
        <div class="row master-form" *ngIf="!hideCallSearchCretria">
            <div class="col-sm-6 col-lg-2">
                <div class="form-group">
                    <div>
                        <label for="callerPhone">{{ 'PHONE' | translate }}</label>
                        <input type="text" class="form-control form-control-sm" formControlName="callerPhone"
                            (keyup.enter)="handleCallerPhoneKeyEnter()" numbersOnly
                            (change)="onMobileChange(callCenterReservationForm.value.callerPhone)">
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-lg-2">
                <div class="form-group">
                    <div>
                        <sanabel-selectize appcode="1162" formControlName="customerId"
                            (clicked)="getCustomerData($event)">
                        </sanabel-selectize>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-lg-2">
                <div class="form-group">
                    <div>
                        <sanabel-selectize appcode="1023" #previousPatient formControlName="previousPatient"
                            (clicked)="getPreviosPatData($event)">
                        </sanabel-selectize>
                    </div>
                </div>
            </div>
            <div class="col-sm-2" style="padding-top :28px;" *ngIf="addSecMobileNumber">
                <button type="button" class="btn btn-info" (click)="addPhone()">
                    {{ 'ADDPHONE' | translate }}</button>
            </div>
            <div class="col-sm-2" >
                <div class="form-group">
                    <sanabel-selectize appcode="14387" #previousCalls  formControlName="perviousCalling" [SearchKeys]="{CallerCode:callerCode}"></sanabel-selectize>
                </div>
            </div>
        </div>
    </div>
    <!-------------------CALL DATA INFO ------------------>
    <h6 class="card-header">{{'CALLDATAINFO' | translate}}</h6>
    <div class="container-fluid"
        [hidden]=" this.patCode==null &&  this.callerData != undefined  && this.callerData['callerCode'] ==null  && this.existedPatient==null">
        <div class="row">
            <div class="col-sm-6 col-md-3 col-lg-3">
                <div class="form-group">
                    <div>
                        <sanabel-selectize appcode="101" formControlName="callReason" (clicked)="reasonFun($event)">
                        </sanabel-selectize>
                    </div>
                </div>
            </div>






            <div class="col-sm-6 col-md-3 col-lg-3">
                <div class="form-group">
                    <div>
                        <sanabel-selectize appcode="843" formControlName="callmethod">
                        </sanabel-selectize>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-3 col-lg-3" [hidden]="reason != 3">
                <div class="form-group">
                    <div>
                        <sanabel-selectize appcode="107" formControlName="reservationType" (clicked)="addOrder($event)">
                        </sanabel-selectize>
                    </div>
                </div>
            </div>

            <!-- <div class="col-sm-6 col-md-3 col-lg-3" *ngIf="reason != 3">
                <div class="form-group">
                    <sanabel-selectize appcode="1016 " formControlName="specialization"></sanabel-selectize>
                </div>
            </div> -->
            <div class="col-sm-4 col-md-3 col-lg-3" *ngIf="reason == 3">
                <div class="form-group">
                    <label for="startDate">{{ 'ReservationDate' | translate }}</label>
                    <div class="input-group">
                        <input class="form-control" placeholder="{{'ReservationDate' | translate}}"
                            formControlName="reservationDate" ngbDatepicker #dp="ngbDatepicker"
                            (navigate)="reservationDateClicked($event)">
                        <div class="input-group-addon" (click)="dp.toggle()">
                            <i class="fa fa-calendar-minus-o"></i>
                        </div>
                        <icon-action (clicked)="onClicked($event)" [appCodes]="[6783]">
                        </icon-action>
                        <!-- <div class="col-3  align-items-center mt-2" (click)="getEarliestDate()"
                            style="cursor: pointer;color: #4f9be6; font-weight: bold;">
                            <span>{{'TheEarliestDate' | translate}} </span>
                        </div> -->
                    </div>
                </div>
            </div>

            <!-- <div class="col-sm-4 col-md-1 col-lg-1" *ngIf="reason == 3">
                <div class="form-group">
                    <icon-action (clicked)="onClicked($event)" [appCodes]="[1]">
                    </icon-action>
                </div>
            </div> -->
            <div class="col-sm-6 col-md-2 col-lg-3" *ngIf="orderType == 3">
                <div class="form-group">
                    <sanabel-selectize appcode="1113" formControlName="device" [SearchKeys]="{ServiceType:2}"
                        (clicked)="getDeviceSlotTime($event)"></sanabel-selectize>
                </div>
            </div>

            <div class="col-sm-6 col-md-2 col-lg-3" *ngIf="reason == 5">
                <div class="form-group">
                    <sanabel-selectize appcode="1014" formControlName="docId"></sanabel-selectize>
                </div>
            </div>
            <div class="col-sm-6 col-md-2 col-lg-3" *ngIf="orderType == 2 || reason != 3">
                <div class="form-group">
                    <div>
                        <sanabel-selectize appcode="1016" formControlName="specialization" #specialitySearch
                            (clicked)="specialityClicked($event)"></sanabel-selectize>
                    </div>
                </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3" *ngIf="orderType == 2">
                <div class="form-group">
                    <div>

                        <sanabel-selectize appcode="1052" formControlName="docId" #doctorSearch
                            (clicked)="doctorClicked($event)"></sanabel-selectize>
                    </div>

                </div>
            </div>

            <div class="col-sm-6 col-md-3 col-lg-3">
                <div class="form-group">
                    <div>
                        <label>{{ 'MEDICALCOMPLAINT' | translate }}</label>
                        <sanabel-selectize formControlName="medicalCompliant" #medicalCompliant appcode="1088"
                            [simpleView]="true" [SearchKeys]="{CallCenterMedicalComplaint:1}">
                        </sanabel-selectize>
                    </div>
                </div>
            </div>


            <div class="row" *ngIf="reason == 2">
                <div class="col-9">
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <label for="complaints">{{ 'COMPLAINTS' | translate }}</label>
                                <textarea class="form-control" type="text" formControlName="complaints" rows="5"
                                    cols="40"></textarea>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="col-3">
                    <div class="row">
                        <div class="col">
                            <div class="form-group">
                                <div>
                                    <sanabel-selectize formControlName="complaintsDesc" #complaintsDescSelectize
                                        appcode="1449">
                                    </sanabel-selectize>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">

                    </div>
                </div>
            </div>


            <div class="col-sm-6 col-md-2 col-lg-3" *ngIf="orderType == 2">
                <div class="form-group">
                    <div>
                        <sanabel-selectize appcode="1466" [SearchKeys]="{ResourceId :DoctorCode, ResourceType:100}"
                            (clicked)="clinicClicked($event)" formControlName="clinicCode"
                            #clinicSearch></sanabel-selectize>
                    </div>
                </div>
            </div>



            <div class="col-sm-6 col-md-3 col-lg-3" *ngIf="orderType == 2||orderType == 3">
                <div class="form-group">
                    <div>
                        <sanabel-selectize [SearchKeys]="{levelNo:3,callCenterFlag:1}" formControlName="serviceCode"
                            #serviceSelectize appcode="1082" (clicked)="onServicsClicked($event)">
                        </sanabel-selectize>
                    </div>

                </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3" *ngIf="orderType == 2 &&orderServiceTypeFlag==true">
                <div class="form-group">
                    <div>
                        <label for="anesthesiologist">{{ 'ANESTHETIST' | translate }}</label>

                        <sanabel-selectize appcode="1014" [SearchKeys]="{Type: 3}" [simpleView]="true"
                            formControlName="anesthesiologist">

                        </sanabel-selectize>

                    </div>

                </div>
            </div>
            <div class="col-sm-6 col-md-3 col-lg-3">
                <div class="form-group">
                    <div>
                        <sanabel-selectize appcode="102" formControlName="callResult"
                            (clicked)="getCallResCode($event)"></sanabel-selectize>
                    </div>
                </div>
            </div>

            <div class="col-sm-6 col-md-3 col-lg-3">
                <div class="form-group">
                    <div>
                        <sanabel-selectize appcode="1065" formControlName="branchAddress"></sanabel-selectize>
                    </div>
                </div>
            </div>

            <div *ngIf="hideSendMessageBox">
                <input type="checkbox" [ngModelOptions]="{standalone: true}" name="sendMessageFlag"
                    [(ngModel)]="sendMessageFlag">Send sms Message
            </div>
            <div class="col-sm-10 col-md-10" *ngIf="reason == 3 && DoctorCode !=null &&specialCode!=null ">
                <timeSlotPicker (currentSlot)="selectedCurrentSlot($event)" [listeningGuid]="listeningGuid"
                    [timeRange]="multiSlotFlag">
                </timeSlotPicker>
            </div>
            <div class="col-sm-10 col-md-10" *ngIf="orderType == 3">
                <app-resource-free-dates (currentSlot)="selectedDeviceCurrentSlot($event)">
                </app-resource-free-dates>
            </div>
            <div class="col-sm-2 col-md-2">
                <button class="btn btn-info rounded-0  mt-2 mb-2 p-2" (click)="openDoctorMonthDates()">
                    {{ 'PO_APPOINTMENT' | translate }}
                </button>
            </div>

        </div>


        <div class="row">
            <!-- <div class="col-sm-2">
                <div class="form-group">
                    <div>
                        <label for="callerPhone">{{ 'CallSort' | translate }}</label>
                        <input type="number" class="form-control form-control-sm" formControlName="callSort">
                    </div>
                </div>
            </div> -->
            <div class="col-sm-12">
                <div class="form-group">
                    <label for="callNotes">{{ 'NOTES' | translate }}</label>
                    <textarea class="form-control" type="text" formControlName="callNotes" rows="1"
                        cols="40"></textarea>

                </div>

            </div>
        </div>
        <div class="row" *ngIf="reason ==1">
            <div class="col">
                <inquery-managment></inquery-managment>
            </div>
        </div>
    </div>

    <!----------------------CCCALL BENIFICARY --------------data-target="#demo" data-toggle="collapse"------->
    <div class="container-fluid" *ngIf="!existedPatient">
        <div class="row">
            <div class="col-sm-3">
                <button type="button" (click)="displayCallerInfo = !displayCallerInfo">
                    {{'CCCALLBENIFICARYINFO' | translate}}
                    <i class="fa"
                        [ngClass]="{'fa-chevron-circle-up':displayCallerInfo,'fa-chevron-circle-down':!displayCallerInfo}"></i>
                </button>
            </div>
        </div>
    </div>
    <!-------------------------------------------------------------->
    <div class="card-block card-outline-primary" [hidden]="!displayCallerInfo">
        <h6 class="card-header">{{'BasicData' | translate}}</h6>
        <div class="row col-sm-12">
            <div class="col-11">
                <name-component [namingTranslationSetting]="namingTranslationSettings" #name></name-component>
            </div>
        </div>
    </div>
    <div [hidden]="!displayCallerInfo">
        <h6 class="card-header">{{'IDENTITY' | translate}}</h6>
        <div class="container-fluid py-3">
            <div class="row">
                <div class="col-sm-6">
                    <identity-component #identity (identityValueInfoEmitted)="identityValueInfoEmitted($event)">
                    </identity-component>
                </div>

                <div class="col-sm-3 form-group">
                    <label for="birthPlace">{{'BirthPlace' | translate}}</label>
                    <input class="form-control form-control-sm" type="text" id="birthPlace" formControlName="birthPlace"
                        tabindex="12">
                </div>
                <div class="col-1">
                    <label>
                        {{'APPROXAGE' | translate}}
                    </label>
                    <input type="number" class="form-control" formControlName="approxAge" autofocus #approxAge
                        (change)="onChange(approxAge.value)">
                </div>
                <div class="col-sm-2">
                    <div class="form-group">
                        <label for="birthDateNgb">{{ 'BIRTHDATE' | translate }}</label>
                        <div class="input-group input-group-sm">
                            <input class="form-control" placeholder="{{'BIRTHDATE' | translate}}"
                                formControlName="birthDateNgb" ngbDatepicker [minDate]="{'year':1900,'month':1,'day':1}"
                                [maxDate]="today" #birthDateNgb="ngbDatepicker">
                            <div class="input-group-addon" (click)="birthDateNgb.toggle()">
                                <i class="fa fa-calendar"></i>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="col-3 col-sm-3 col-md-3 col-lg-3">
                    <div class="form-group">
                        <label>{{'MOBILENUMBER' | translate}}</label>
                        <input class="form-control form-control-sm" type="text" formControlName="mobile" tabindex="18"
                            (blur)="onKeyMobile($event)" />
                    </div>
                    <div *ngIf="callCenterReservationForm.controls['mobile'].errors && (callCenterReservationForm.controls['mobile'].dirty || callCenterReservationForm.controls['mobile'].touched)"
                        class="alert alert-danger">

                        <small [hidden]="!callCenterReservationForm.controls['mobile'].errors.pattern">
                            {{'INCORRECTMOBILE' | translate}}
                        </small>

                        <small [hidden]="!callCenterReservationForm.controls['mobile'].errors.pattern">
                            {{'INCORRECT' | translate}}
                        </small>
                    </div>
                </div>
                <div class="col-3 col-sm-3 col-md-3 col-lg-3">
                    <div class="form-group">
                        <label>{{'ALTERNATIVEMOBILENUMBER' | translate}}</label>
                        <input class="form-control form-control-sm" type="text" formControlName="mobile2" tabindex="18"
                            (blur)="onKeyMobile($event)" />
                    </div>
                    <div *ngIf="callCenterReservationForm.controls['mobile'].errors && (callCenterReservationForm.controls['mobile'].dirty || callCenterReservationForm.controls['mobile'].touched)"
                        class="alert alert-danger">

                        <small [hidden]="!callCenterReservationForm.controls['mobile'].errors.pattern">
                            {{'INCORRECTMOBILE' | translate}}
                        </small>

                        <small [hidden]="!callCenterReservationForm.controls['mobile'].errors.pattern">
                            {{'INCORRECT' | translate}}
                        </small>
                    </div>
                </div>

                <div class="col-12 col-sm-6 col-md-6 col-lg-3">
                    <label>{{ 'GENDER' | translate }}</label>
                    <sanabel-selectize appcode="1" [simpleView]="true" formControlName="gender">
                    </sanabel-selectize>
                </div>
                <div class="col-sm-6 col-lg-3">
                    <label class="small">{{'HOWTOREACHUS' | translate}}</label>
                    <sanabel-selectize appcode="315" [tabindex]="15" formControlName="howToReachUs" [simpleView]="true">
                    </sanabel-selectize>
                </div>

                <div class="col-sm-6 col-lg-3">
                    <label class="small">{{'Parent' | translate}}</label>
                    <sanabel-selectize appcode="1023" [tabindex]="16" formControlName="parentId" [simpleView]="true">
                    </sanabel-selectize>
                </div>
            </div>
            <div class="container-fluid">
                <address-component #address [tabindex]="21"></address-component>
            </div>

            <div class="container-fluid">
                <h6 class="card-header">{{'Contract' | translate}}</h6>
                <div class="row">
                    <div class="col">
                        <Contract-Id #therapeuticCards (contractValueInfoEmitted)="contractValueInfoEmitted($event)">
                        </Contract-Id>
                    </div>
                </div>
            </div>


        </div>
    </div>
</form>
<!-------------------------------------------------------------->
<div class="container-fluid">
    <btns-ctrl [appCodes]="appCodesList" (clicked)="onClicked($event)"></btns-ctrl>
</div>
<!---------------------PopUp Area----------------------------------------->
<div>
    <block-modal-container #popup (close)="onpopupClose($event)">
        <ng-container class="modal-body" [ngComponentOutlet]="dynamicComponent"></ng-container>
    </block-modal-container>
</div>
<div>
    <block-modal-container #callListPopup (close)="onpopupClose($event)">
        <ng-container class="modal-body" [ngComponentOutlet]="callListDynamicComponent"></ng-container>
    </block-modal-container>
</div>

<div>

    <block-modal-container #popup2 (close)="onpopupClose($event)">
        <ng-container class="modal-title">
            <h3 style="font-family: inherit">
                {{ ModalTitle | translate }}
            </h3>
        </ng-container>
        <ng-container class="modal-body">
            <div *ngIf="compType==200">
                <emr-chronic [docId]='callerData?.docId' [addNewChronic]="false"></emr-chronic>
            </div>
        </ng-container>
    </block-modal-container>
</div>
<!-------------------------------------------------------------->

<style>
    .callInfo {
        background-color: #e9f6fb;
        height: 71px;
        font-size: 16px;
        margin-bottom: 10px;
    }


    .savedCallInfo {
        background-color: #d4edda;
        border: 1px solid #c3e6cb;
        border-radius: 5px;
        height: 71px;
        font-size: 16px;
        margin-bottom: 10px;
        color:#155724
    }
</style>